/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { type WithIsActiveItemRequestBuilder, WithIsActiveItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /RevVardoc/{id}
 */
export interface RevVardocItemRequestBuilder extends BaseRequestBuilder<RevVardocItemRequestBuilder> {
    /**
     * Gets an item from the ApiSdk.RevVardoc.item.item collection
     * @param isActive Unique identifier of the item
     * @returns {WithIsActiveItemRequestBuilder}
     */
     byIsActive(isActive: boolean) : WithIsActiveItemRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const RevVardocItemRequestBuilderUriTemplate = "{+baseurl}/RevVardoc/{id}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const RevVardocItemRequestBuilderNavigationMetadata: Record<Exclude<keyof RevVardocItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byIsActive: {
        requestsMetadata: WithIsActiveItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["isActive"],
    },
};
/* tslint:enable */
/* eslint-enable */
